var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarLeftSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sidebar-left"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Square",
    fill: "none",
    height: 18,
    id: "Square-2",
    rx: 2,
    ry: 2,
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    width: 18,
    x: 3,
    y: 3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 9,
    x2: 9,
    y1: 21,
    y2: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLeftSvgrepoCom);
export default __webpack_public_path__ + "static/media/sidebar-left-svgrepo-com.d8b54f3d44959f66421bb81c8834f844.svg";
export { ForwardRef as ReactComponent };